var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypescriptLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 43 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1025,-1923)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,1,1025,1923)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 0.847,
    y: 0.156,
    width: "41.771px",
    height: "41.771px",
    transform: "matrix(0.99455,0,0,0.99455,0,0)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "42px",
    height: "42px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADhUlEQVRYhe2ZX2hTVxzHP/fm5rYmXRsTUls3RUFNpUasCroGBEUfhrA97EEmFfoWXxSGIIL/WYUK9UmFDWXMPhSmsCEosjctTMcmRG3XlrabUumf9Z+tt0lscpPrw01Gbm6jNcTbPOT7lu85J+fD+fM75/6OQIYaTjxsAA4D24FNgIy1igHdwGPg+1BrYyhdIKQAJeAUcBKQLIbLJRW4ALSEWhtVMWWeAs5SPJCgs5xFHzyE1HT/SXFBZioO7BDR12SxQgLYgaCIvnGKXdtF9N1d7PKLWB+C8pEsvr9OcagEWmiVQAutEmihVQIttEqghdairneSTcAh2/LqIBpLEE9oJn+NdxmrPOVUV8k4ZBtKVGUmotL9co5JJZYf6K665bQ1+fICPX1zkLuhCQAEAb7Y4uWbxhrqP6vI2ebek0lO/jzw4aCF0rH9azgYqH1vPW+l+UJnGejXO1YsCDk6M89sRMXlkKhxleVsvyjQp0MK37b3GTxnmY2WA+sN3plbgyhR1eD1jYQB2LvJY/AHxyIc7+jnxUT0f89dYWev34N/lXlZLAp0SonzoPeVwXM5zU0fDcwwpcRNvigK+FcbO/+pc8QACTA9F+fmozFu/WFmsCQ8iQKUScauPl9flbO+Zg4S1oCqCY3nWaO3v8HLpSYfn7rLF/UflgX89s4Rk7e73s3tY1u4eHADvlrnO9tbBno3NMGV34ZMwV8UBfb5PXQc2Uxbkw93hX3B9paBahr8eH+YQ1e7GBiLmMoFAfbUu+k4spl1KxymcsvP+v7RME1XntF25wXD029M5dWVMi0H1mETBYO/JJeSeEKj4/dRvrr0hO9++QfljTH2bqh1sjMrKizp7SmZ1Pj1r3GC13pMISl7+i0DDfhcOcv6RsL8Nztv8LLBLQO93LyRy80bqVvpRMxYf4IAX27zms75p0OK4beEno62JP8U8LkI+FzE1CT/jkcJzydY7Sk33ZZmIyq9w+FMKyah58y3WgGaliyJ1K1cOMBHY0mO3ugjpiYz7S4RPbH/0XW/Zzq7c4OSSY3O3lcEr/9NV9a0A4/zTo3bbQIB33KD97B/5p0wDtnG1rWVVFfKuD+xUyaJTM3FmHwd59mQwvhr8ycIqdR4+lXkHHpivxh1LtTaeD49ii2Ahv4CsfBha73i6M83FyD1zpRWahkE0fP6fpbmQawLfd/8kPkg9hb9RBF1NBMZOAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescriptLogo);
export default __webpack_public_path__ + "static/media/Typescript_logo.612c54eaa8090635054c5efddf5f69d6.svg";
export { ForwardRef as ReactComponent };